<template>
    <div>
        <div class="d-flex flex-column gap-2 ans-q-container " v-for="(question,idx) in this.template.multipleChoices"
             :key="idx">
            <div>Question {{idx+1}}</div>
            <div class="q-content">{{question['content']}}</div>
            <div class="d-flex gap-3">
                <div v-for="(a,index) in question.answers" class="d-flex gap-4 ans-content">
                    <div class="m-c-answer-container d-flex gap-2">
                        <div>

                            <input @click="checkHandler($event, index,idx)" :id="idx+'-'+index"
                                   type="checkbox"
                                   :value="a.value" v-model="a.is_selected" class="form-check-input"/>

                        </div>
                        <div class="d-flex align-items-center">{{typeof a.value === "object" ? a.value[0] : a.value}}</div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        name: 'multipleChoices-component',
        data() {
            return {}
        },
        async mounted() {

        },
        props: ['template', 'userAnswers'],
        methods: {
            checkHandler(e, aidx, idx) {

                this.template.multipleChoices[idx]['answers'][aidx].is_selected = !this.template.multipleChoices[idx]['answers'][aidx].is_selected;
                // this.userAnswers.answers.push({...this.template.multipleChoices[idx]['answers'][aidx]});
                this.userAnswers.answers.forEach((answer,index) => {
                    if(answer['id'] === this.template.multipleChoices[idx]['answers'][aidx]['id']){
                        this.userAnswers.answers.splice(index, 1);
                    }else{

                    }
                });

                if(this.template.multipleChoices[idx]['answers'][aidx]['is_selected'])
                    this.userAnswers.answers.push({...this.template.multipleChoices[idx]['answers'][aidx]});

                console.log(this.userAnswers.answers)
                this.template.changeFlag = true;
                // console.log(this.answers.multipleChoices[index]);
            }
        }
    }
</script>

<style scoped>
    .question-container {
        border-bottom: 1px solid #e65c00;
        margin-bottom: 10px;
        padding-bottom: 10px;
    }

    .question-container:last-child {
        border-bottom: none;
    }

    .form-check-input {
        border: 1px solid #e95626 !important;;
        background-color: transparent !important;
    }

    .form-check-input:checked {
        background-image: url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e") !important;
        border: 2px solid var(--border-color-data-table) !important;;
        background-color: #e95626 !important;
        box-shadow: 0 0 0 1px #e95626 !important;
    }
</style>